module.exports = __webpack_public_path__ + "static/media/shipPicOne.964f724f.jpeg";